
/* Generated apis ---------------------- */
import { to } from 'react-lib/utils'
import BaseService from  'react-lib/apis/services/BaseService'
import config from '../../config/config'
import OADashboardAppointmentSerializer from '../types/OADashboardAppointmentSerializer_apps_PRX'


const HOST = `${config.API_HOST}`
/* ['ListAPIView', 'SetLanguageContextMixin'] */
/* params: 'division', 'hn', 'patient_name', 'patient_dob', 'division', 'doctor_name', 'start_date', 'end_date' */
/* data:  */
const OfficialAccountDashboardAppointmentView : 
{
  list:     ({params, apiToken, extra}:
             { 
                params?: any,
                apiToken?: any,
                extra?: any,
            }) => any,
} = 
{
  list: async ({params, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(base.client.get(`${HOST}/apis/PRX/official-account/dashboard-appointment/`,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },
}

export default OfficialAccountDashboardAppointmentView

